<template>
    <ModalFormCard class="modal-default" :action='"/admin/actions/invoice/" + value.invoice_id + "/refund"'>
        <template #title>Refund Payment</template>

        <template #default="{ saving, errors }">
            <p class='text-15 font-semibold'>Refund {{ subscription.location_area.name }}</p>

            <Select class='mt-2' name='reason'
                placeholder='Select reason'
                v-model:value='value.reason'
                label='Reason refund' 
                :options="[
                    { value: 'Poor performance' },
                    { value: 'Other' },
                ]" 
            />

            <Textarea name='reason_other' v-model:value='value.reason_other' 
                label='Other reason' v-if='value.reason == "Other"' 
                class='mt-4'
            /> 

            <Select class='mt-4' name='invoice_id'
                v-model:value='value.invoice_id'
                label='Invoice to refund'
                placeholder='Select invoice' 
                :options="invoices != null ? invoices.map(i => {
                    return { value: i.id, html: i.id, invoice: i }
                }) : []" 
                @update:value='setPartialValue'
            >
                <template #option="{ option, selected }">
                    <div class='flex items-center justify-between'>
                        <p>{{ $moment(option.invoice.stripe_period_from).format('DD/MM/YYYY') }}</p>
                        <p v-if='!selected'>{{ option.invoice.plan.name }} {{ $help.dp(option.invoice.total) }}</p>
                    </div>
                </template>
            </Select>

            <template v-if='selectedInvoice != null'>
                <!-- <div class='grid grid-cols-2 text-14 text-grey-900 gap-1 mt-4'>
                    <p>Plan: {{ selectedInvoice.plan.name }}</p>
                    <p>Invoice total: {{ $help.dp(selectedInvoice.total) }}</p>
                    <p>Period from: {{ $moment(selectedInvoice.ads_period_from).format('DD/MM/YYYY') }}</p>
                    <p>Period to: {{ $moment(selectedInvoice.ads_period_to).format('DD/MM/YYYY') }}</p>
                    <p>Ad spent: {{ $help.dp(selectedInvoice.spent) }}</p>
                    <p>Ad spend: {{ $help.dp(selectedInvoice.spend) }}</p>
                    <p>Payment attempts: {{ selectedInvoice.payments.length }}</p>
                    <p>Paid on: {{ $moment(selectedInvoice.payments[selectedInvoice.payments.length-1].charge_at).format('DD/MM/YYYY') }}</p>
                </div> -->

                <Select name='full' class='mt-4'
                    v-model:value='value.full'
                    label='Refund type' 
                    :options="[
                        { value: 'Full refund' },
                        { value: 'Partial refund' },
                    ]" 
                />

                <div class='grid grid-cols-2 mt-4 gap-4' v-if='value.full == "Partial refund"'>
                    <Input name='partial' v-model:value='value.partial' label='Amount to refund' />

                    <InputCheckbox class='mt-10' :checked='value.include_vat' 
                        @change='value.include_vat = !value.include_vat' value="1">
                        <p class="text-14 text-grey-900 pl-2">Include VAT</p>
                    </InputCheckbox>
                </div>

                <p class='text-15 font-semibold mt-6'>Refund breakdown</p>

                <div class='text-15 flex items-center justify-between py-4'>
                    <p>Sub total</p>
                    <p>{{ $help.dp(total / 1.2) }}</p>
                </div>
                <div class='text-15 flex items-center justify-between border-y border-grey-500 py-4'>
                    <p>VAT</p>
                    <p>{{ $help.dp(total - (total / 1.2)) }}</p>
                </div>
                <div class='text-15 flex items-center justify-between py-4'>
                    <p>Total</p>
                    <p>{{ $help.dp(total) }}</p>
                </div>
            </template>

            <InputCheckbox class='mt-4' name="accepted" value="1">
                <p class="text-14 text-grey-900 pl-2">Are you sure you want to refund {{ $help.dp(total) }}?</p>
            </InputCheckbox>

            <div class="modal-buttons pt-6">
                <ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
					Refund
				</ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'

    export default {
        mixins: [Modal],

        data() {
            return {
                invoices: null,
                value: {
                    reason: null,
                    reason_other: '',
                    invoice_id: null,
                    full: 'Full refund',
                    partial: 0,
                    include_vat: true
                }
            }
        },

        created() {
            this.getInvoices()
        },

        methods: {
            getInvoices() {
                this.$axios.post('/admin/actions/subscription/'+this.subscription.id+'/invoices')
                    .then(res => {
                        this.invoices = res;
                        console.log(this.invoices)
                    })
            },

            setPartialValue() {
                this.value.partial = this.selectedInvoice.total
            }
        },

        computed: {
            subscription() {
                return this.editingModel
            },

            selectedInvoice() {
                return this.invoices == null ? null : this.invoices.find(i => i.id == this.value.invoice_id)
            },

            total() {
                if (this.value.include_vat) {
                    return this.value.partial
                }

                return this.value.partial * 1.2
            }
        }
    }
</script>